import React from 'react';

const ProposalDisplaySettings = ({ displaySettings = {
  showScopeDescription: true,
  showCostCodeDescription: false,
  showQuantity: false,
  showUnit: false,
  showPrice: false,
  showCostCodes: false,
  expandGroups: false,
  separateGroups: false,
  showTotalCost: true
}, handleDisplaySettingChange }) => {
  
  // Ensure all display settings have default values with explicit boolean conversion
  const settings = {
    showScopeDescription: displaySettings.showScopeDescription !== undefined ? Boolean(displaySettings.showScopeDescription) : true,
    showCostCodeDescription: displaySettings.showCostCodeDescription !== undefined ? Boolean(displaySettings.showCostCodeDescription) : false,
    showQuantity: displaySettings.showQuantity !== undefined ? Boolean(displaySettings.showQuantity) : false,
    showUnit: displaySettings.showUnit !== undefined ? Boolean(displaySettings.showUnit) : false,
    showPrice: displaySettings.showPrice !== undefined ? Boolean(displaySettings.showPrice) : false,
    showCostCodes: displaySettings.showCostCodes !== undefined ? Boolean(displaySettings.showCostCodes) : false,
    // Special handling for group settings that might be undefined
    expandGroups: displaySettings.expandGroups !== undefined ? Boolean(displaySettings.expandGroups) : false,
    separateGroups: displaySettings.separateGroups !== undefined ? Boolean(displaySettings.separateGroups) : false,
    showTotalCost: displaySettings.showTotalCost !== undefined ? Boolean(displaySettings.showTotalCost) : true
  };

  // Custom checkbox component with styling
  const StyledCheckbox = ({ checked, onChange, children }) => (
    <label className="flex items-center text-sm cursor-pointer hover:bg-gray-50 p-2 rounded-md transition-colors duration-150">
      <div className="relative">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="sr-only"
        />
        <div className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-all duration-200 ${
          checked 
            ? 'bg-blue-600 border-blue-600 shadow-sm' 
            : 'bg-white border-gray-300 hover:border-gray-400'
        }`}>
          {checked && (
            <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          )}
        </div>
      </div>
      <span className={`ml-3 text-gray-700 ${checked ? 'font-medium' : ''}`}>
        {children}
      </span>
    </label>
  );

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-gray-900">Display Options</h3>
      
      {/* Content Display Options */}
      <div className="space-y-1">
        <h4 className="text-sm font-medium text-gray-700 mb-2">Content</h4>
        <StyledCheckbox
          checked={settings.showScopeDescription}
          onChange={() => handleDisplaySettingChange('showScopeDescription')}
        >
          Scope Descriptions
        </StyledCheckbox>
        <StyledCheckbox
          checked={settings.showCostCodeDescription}
          onChange={() => handleDisplaySettingChange('showCostCodeDescription')}
        >
          Cost Code Descriptions
        </StyledCheckbox>
      </div>

      {/* Quantities & Pricing Options */}
      <div className="space-y-1">
        <h4 className="text-sm font-medium text-gray-700 mb-2">Details</h4>
        <StyledCheckbox
          checked={settings.showQuantity}
          onChange={() => handleDisplaySettingChange('showQuantity')}
        >
          Show Quantities
        </StyledCheckbox>
        <StyledCheckbox
          checked={settings.showUnit}
          onChange={() => handleDisplaySettingChange('showUnit')}
        >
          Show Units
        </StyledCheckbox>
        <StyledCheckbox
          checked={settings.showPrice}
          onChange={() => handleDisplaySettingChange('showPrice')}
        >
          Show Pricing
        </StyledCheckbox>
        <StyledCheckbox
          checked={settings.showTotalCost}
          onChange={() => handleDisplaySettingChange('showTotalCost')}
        >
          Show Total Cost
        </StyledCheckbox>
      </div>
      
      {/* Group Display Options */}
      <div className="space-y-1 pt-2 border-t border-gray-200">
        <h4 className="text-sm font-medium text-gray-700 mb-2">Group Display</h4>
        <StyledCheckbox
          checked={settings.expandGroups}
          onChange={() => handleDisplaySettingChange('expandGroups')}
        >
          Expand All Groups
        </StyledCheckbox>
        <StyledCheckbox
          checked={settings.separateGroups}
          onChange={() => handleDisplaySettingChange('separateGroups')}
        >
          Separate Grouped/Non-Grouped Items
        </StyledCheckbox>
      </div>
    </div>
  );
};

export default ProposalDisplaySettings;